import { render, staticRenderFns } from "./ReferrerHistory.vue?vue&type=template&id=36472ed0&scoped=true&"
import script from "./ReferrerHistory.vue?vue&type=script&lang=js&"
export * from "./ReferrerHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReferrerHistory.vue?vue&type=style&index=0&id=36472ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36472ed0",
  null
  
)

export default component.exports